/* global L:false */
import angular from 'angular';
import { compact, forEach, merge, values } from 'lodash';

module.exports = angular.module('common.directives.details-map', [
  require('../filters/currency'),
  require('angular-animate'),
])
.directive('ocDetailsMap', function(currencyFilter, MapboxConfig, $animate, $compile, $templateRequest) { // eslint-disable-line max-len
  var overlayTemplate = $templateRequest('/templates/common/directives/details_map_marker.html');

  return {
    restrict: 'C',
    scope: {
      ngModel: '=',
      hover: '=?',
      subjectAddress: '=',
      subjectPrice: '=',
    },
    link: function(scope, element, attrs) {
      var map = null
        , subjectPosition = null
        , markers = {}
        , container = element.append('<div>').find('div').css({ 'height': '100%' })
        , overlay = element.css({ position: 'relative' }).append('<div class="overlay-container">').find('div').next().css({ 'height': '100%', position: 'absolute', top: 0 }); // eslint-disable-line max-len

      scope.$watchGroup([attrs.ngModel, attrs.subjectAddress, attrs.subjectPrice], function() {
        rebuildMap();
      });

      function rebuildMap() {
        var listings = scope.ngModel
          , subjectAddress = scope.subjectAddress
          , subjectPrice = scope.subjectPrice;
        if (!listings || !subjectAddress || !subjectPrice) return;

        // Clear out any remnants
        container[0].innerHTML = '';
        overlay[0].innerHTML = '';

        subjectPosition = [parseFloat(subjectAddress.latitude), parseFloat(subjectAddress.longitude)]; // eslint-disable-line max-len
        L.mapbox.accessToken = MapboxConfig.accessToken;
        L.mapbox.config.FORCE_HTTPS = true;
        map = L.mapbox.map(element.children()[0], MapboxConfig.defaultMap, {
          attributionControl: { compact: true },
          boxZoom: false,
          center: subjectPosition,
          doubleClickZoom: false,
          dragging: false,
          keyboard: false,
          scrollWheelZoom: false,
          touchZoom: false,
          zoom: 14,
          zoomControl: false,
        });
        map.on('viewreset', function() {
          forEach(values(markers), positionMarkerOverlay);
        });
        map.on('move', function() {
          forEach(values(markers), positionMarkerOverlay);
        });

        var pinLayer = makeCompLayer().addTo(map)
          , compGeoJson = [];

        var subjectGeoJson = makePriceMarker(subjectPosition, null, subjectPrice);
        compGeoJson.push(subjectGeoJson);

        forEach(compact(listings), function(listing) {
          if (!listing.coordinates) return;

          var position = [listing.coordinates.lat, listing.coordinates.lng];
          var marker = makePriceMarker(position, listing, listing.price_cents);
          compGeoJson.push(marker);
        });

        pinLayer.setGeoJSON({
          type: 'FeatureCollection',
          features: compGeoJson,
        });
        map.fitBounds(pinLayer.getBounds(), {
          animate: false,
          paddingBottomRight: [50, 10],
          paddingTopLeft: [50, 30]
        });
      }

      // We want the pin overlays/popups to display outside of the edges of the
      // map and not be hidden by the map container's `overflow: hidden`. As
      // such, the overlays need to exist in a different part of the DOM and be
      // positioned using this method.
      function positionMarkerOverlay(marker) {
        var listing = marker.feature.properties.listing
          , point = map.latLngToContainerPoint(listing.coordinates);
        if (point && marker.div) {
          marker.div.style.left = point.x + 'px';
          marker.div.style.top = point.y + 'px';
        }
      }

      function makeCompLayer() {
        var pinLayer = L.mapbox.featureLayer();
        pinLayer.overlay = overlay;
        pinLayer.on('layeradd', function(e) {
          var marker = e.layer
            , feature = marker.feature
            , listing = feature.properties.listing;

          marker.hoverOn = function() {
            var iconOpts = merge({}, feature.properties.icon, {
              className: feature.properties.icon.className + ' hover',
            });
            marker.setIcon(L.divIcon(iconOpts));
            marker.setZIndexOffset(2000);
            if (marker.div)
              $animate.addClass(marker.div, 'hover');
          };

          marker.hoverOff = function() {
            marker.setIcon(L.divIcon(feature.properties.icon));
            marker.setZIndexOffset(null); // null is required here, not undefined
            if (marker.div)
              $animate.removeClass(marker.div, 'hover');
          };

          marker.onmouseenter = function() {
            scope.$apply(function() {
              if (listing) scope.hover = listing.listing_id;
            });
          };

          marker.onmouseleave = function() {
            scope.$apply(function() {
              scope.hover = null;
            });
          };

          if (!marker.div && listing) {
            markers[listing.listing_id] = marker;
            overlayTemplate.then(function(template) {
              var compileScope = scope.$new(true);
              compileScope.listing = listing;
              marker.div = $compile(template)(compileScope)[0];

              marker.div.addEventListener('mouseenter', marker.onmouseenter);
              marker.div.addEventListener('mouseleave', marker.onmouseleave);

              pinLayer.overlay.append(marker.div);
              marker.div.style.marginLeft = -marker.div.offsetWidth/2 + 'px';
              positionMarkerOverlay(marker);
            });
          }

          if (feature.properties.isSubject)
            marker.setZIndexOffset(1000); // put subject on top of all other markers

          marker.setIcon(L.divIcon(feature.properties.icon));
        });

        pinLayer.on('mouseover', function(e) {
          var marker = e.layer;
          marker.hoverOn();
          marker.onmouseenter();
        });
        pinLayer.on('mouseout', function(e) {
          var marker = e.layer;
          marker.hoverOff();
          marker.onmouseleave();
        });

        return pinLayer;
      }

      function makePriceMarker(latlon, listing, price) {
        var className = 'price-icon';
        if (!listing) className += ' subject';

        return {
          'type': 'Feature',
          'geometry': {
            'type': 'Point',
            'coordinates': [latlon[1], latlon[0]],
          },
          'properties': {
            'icon': {
              'className': className,
              'html': currencyFilter(price),
              'iconSize': null,
            },
            'listing': listing,
            'isSubject': !listing,
          }
        };
      }

      scope.$watch('hover', function(listing, previous) {
        if (markers[previous])
          markers[previous].hoverOff();

        if (markers[listing])
          markers[listing].hoverOn();
      });
    }
  };
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/common/directives/details-map.js
 **/